import { tokens } from '@fluentui/react-theme';
import { __styles, mergeClasses } from '@griffel/react';
import { useToggleButtonStyles_unstable } from '@fluentui/react-button';
const useBaseStyles = /*#__PURE__*/__styles({
  selected: {
    sj55zd: "f16muhyy"
  }
}, {
  d: [".f16muhyy{color:var(--colorBrandForeground1);}"]
});
/**
 * Apply styling to the ToolbarRadioButton slots based on the state
 */
export const useToolbarRadioButtonStyles_unstable = state => {
  'use no memo';

  useToggleButtonStyles_unstable(state);
  const toggleButtonStyles = useBaseStyles();
  state.root.className = mergeClasses(state.root.className, state.checked && toggleButtonStyles.selected);
  return state;
};